import { ILinkConfig } from '@/finsight/ui/common/components/header/Header/Links/linksConfig';
import staticUrls from '@finsight/urls/static';
import cfrUrl from '@/creditflowresearch/infrastructure/url';

const linksConfig: ILinkConfig[] = [
  {
    url: cfrUrl.getUrl('/'),
    dataTest: 'marketData',
    label: 'Market Data',
  },
  {
    url: staticUrls.getSolutionsUrl(),
    dataTest: 'solutions',
    label: 'Solutions',
  },
  {
    url: staticUrls.getAboutUrl(),
    dataTest: 'aboutUs',
    label: 'About Us',
  },
  {
    url: staticUrls.getCareersUrl(),
    dataTest: 'careers',
    label: 'Careers',
  },
  {
    url: staticUrls.getContactUrl(),
    dataTest: 'contact',
    label: 'Contact',
  },
];

export default linksConfig;
